import React, { useEffect, useId, useState } from "react";
import styled from "styled-components";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  LabelStyled,
  TextStyled,
} from "../../../components/styled/Elements";
import { StepsWrapper } from "./Styled";
import { AvatarPlaceholders } from "../../../components/styled/AllImages";
import { Col, Row } from "react-bootstrap";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { useTranslation } from "react-i18next";
import { SelectionDropdown } from "../../../components/styled/FormElements";
import {
  cityList,
  OperateList,
  ProvinceList,
} from "../../../helpers/dummyConstants";
import PhoneInputField from "../../../components/common/inputFields/PhoneInput";
import { emailRegex } from "../../../utils";
import ValidationController from "../../../components/common/inputFields/ValidationController";
import { MultiSelectionDropdown } from "../../../components/common/dropdowns/MultiSelectDropdown";

export const Step1 = ({ register, control, errors, cities, watch, profileImage, setProfileImage, provinces }) => {
  const { t } = useTranslation();
  const userName = watch("name");
  const uniqueId = useId();
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileURL = URL.createObjectURL(file);
      setProfileImage(fileURL);
    }
  };
  // Helper function to translate options
  const translateOptions = (options) =>
    options.map((option) => ({
      label: t(option.label), // Translate the label
      value: option.value,
    }));
  // Use helper function to translate each dropdown's options
  const ProvinceListTrans = translateOptions(ProvinceList);
  const OperateListTrans = translateOptions(OperateList);

  return (
    <>
      <StepsWrapper>
        <HeadingStyled className="stepsMainTitle" size="24px">
          {t("PersonalInformation")}
        </HeadingStyled>
        <Box className="profileAvatarContainer">
          <Box className="profileAvatarImg">
            <Box className="profileAvatarImgContainer">
              {/* <AvatarPlaceholder className="profileAvatar" /> */}
              <img className="profileAvatar" src={profileImage} />
            </Box>
            <Box className="profileUserNameWrapper">
              <HeadingStyled className="profileUserName" size="24px">
                {userName}
              </HeadingStyled>
              <ValidationController
                name={"profile"}
                control={control}
                errors={errors}
                validationConfig={{
                  required: `fieldRequired`,
                }}
                renderer={({ field }) => (
                  <>
                    <ButtonStyled
                      label={t("Uploadyourprofilepicture")}
                      bg="var(--white)"
                      border="var(--lightGrey2)"
                      color="var(--themeColor)"
                      type="button"
                      onClick={(event) => {
                        event.preventDefault();
                        document
                          .getElementById(`imageInput-${uniqueId}`)
                          .click();
                      }}
                    />
                    <input
                      id={`imageInput-${uniqueId}`} // Use the unique ID here
                      type="file"
                      accept="image/png, image/jpeg, image/jpg" // Accept only image files
                      style={{ display: "none" }}
                      onChange={(e) => {
                        handleFileChange(e);
                        field.onChange(e.target.files[0]);
                      }}
                    />
                  </>
                )}
              />
            </Box>
          </Box>
        </Box>
        <Box className="stepFormContainer">
          <Row className="mt-3">
            <Col md={6}>
              <ValidatedInput
                name="name"
                type="input"
                fieldType="text"
                placeholder={t("RobertFox")}
                label="FullName"
                className=""
                staric="staric"
                register={register}
                errors={errors}
                validationRules={{
                  required: true,
                }}
              />
            </Col>
            <Col md={6}>
              <ValidatedInput
                name="email"
                type="input"
                fieldType="text"
                placeholder="Email"
                label="Email"
                className=""
                staric="staric"
                register={register}
                errors={errors}
                validationRules={{
                  required: true,
                  pattern: {
                    value: emailRegex,
                    message: "invalidEmail",
                  },
                }}
              />
            </Col>
            <Col md={6}>
              <PhoneInputField
                name="phone"
                label={"phone"}
                placeholder="phone"
                register={register}
                control={control}
                validationRules={{
                  required: true,
                }}
                className={"flex-wrap p-0"}
                staric="staric"
              />
            </Col>
            <Col md={6}>
              <Box className="formEleContainer">
                <LabelStyled className="labelForm">
                  {t("Province")}
                  <span className="staric">*</span>
                </LabelStyled>
                <ValidationController
                  name={"province"}
                  control={control}
                  errors={errors}
                  validationConfig={{
                    required: `fieldRequired`,
                  }}
                  renderer={({ field }) => (
                    <SelectionDropdown
                      name={field.name}
                      placeholder={t("SelectOne")}
                      options={provinces}
                      value={field.value}
                      onChange={(e) => field.onChange(e.target.value)}
                    />
                  )}
                />
              </Box>
            </Col>
            <Col md={6}>
              <Box className="formEleContainer">
                <LabelStyled className="labelForm">
                  {t("City")}
                  <span className="staric">*</span>
                </LabelStyled>
                <ValidationController
                  name={"city_id"}
                  control={control}
                  errors={errors}
                  validationConfig={{
                    required: `fieldRequired`,
                  }}
                  renderer={({ field }) => (
                    <SelectionDropdown
                      name={field.name}
                      placeholder={t("City")}
                      options={cities && cities.length > 0 ? cities.filter(city => city?.region_id == watch("province")) : []}
                      value={field.value}
                      onChange={(e) => field.onChange(e.target.value)}
                    />
                  )}
                />
              </Box>
            </Col>
            <Col md={6}>
              <Box className="formEleContainer">
                <LabelStyled className="labelForm">
                  {t("WeOperatein")}
                  <span className="staric">*</span>
                </LabelStyled>
                <ValidationController
                  name={"we_operate_in"}
                  control={control}
                  errors={errors}
                  validationConfig={{
                    required: `fieldRequired`,
                  }}
                  renderer={({ field }) => (
                    <MultiSelectionDropdown
                      name={field.name}
                      placeholder={t("SelectOne")}
                      options={cities}
                      value={field.value || []}
                      onChange={(selected) => field.onChange(selected)}
                    />
                  )}
                />
              </Box>
            </Col>
            <Col md={6}>
              <ValidatedInput
                name="years_of_experience"
                type="input"
                fieldType="number "
                placeholder="AddExperience"
                label="YearsofExperience"
                className=""
                // staric="staric"
                innerTxt={t("Years")}
                min={0}
                register={register}
                errors={errors}
                validationRules={{
                  required: false,
                }}
              />
            </Col>
            <Col md={6}>
              <ValidatedInput
                name="properties_sold"
                type="input"
                fieldType="text"
                placeholder="AddNoSoldProperties"
                label="PropertiesSold"
                className=""
                // staric="staric"
                register={register}
                errors={errors}
                validationRules={{
                  required: false,
                }}
              />
            </Col>
            <Col md={12}>
              <ValidatedInput
                name="about_me"
                type="textarea"
                fieldType="text"
                placeholder={"Writeaboutyourself"}
                label="Aboutme"
                // staric={true}
                className="combined"
                register={register}
                errors={errors}
                validationRules={{
                  required: false,maxLength: {
                    value: 250,
                    message: "maximum_250_characters_allowed",
                  },
                }}
              />
            </Col>
            <Col md={12}>
              <TextStyled>{t("Briefdescriptionyourprofile")}</TextStyled>
            </Col>
          </Row>
        </Box>
      </StepsWrapper>
    </>
  );
};
